/**
 * GHE (GitHub Enterprise) base URL for building browsable repo links on the
 * Delivery repo page. Mirrors the lambda-side `GHE_BASE_URL` default
 * (repo-scanner/repo-discovery) so dashboard and pipeline agree without a
 * shared constant across the Lambda/Vite build boundary.
 */
export const GHE_BASE_URL: string = import.meta.env.VITE_GHE_BASE_URL ?? 'https://ghe.coxautoinc.com';
